import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { FormControlLabel, Hidden, Switch } from '@mui/material';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { preventDefault } from 'shared/hooks/utils';
export const TurnOn = memo(function TurnOn({ onChange, is_active, selected, }) {
    const onClick = useCallback((e) => {
        preventDefault(e);
        onChange(!is_active);
    }, [onChange, is_active]);
    return (_jsxs(ErrorBoundary, { children: [_jsx(Hidden, { mdDown: true, children: _jsx(FormControlLabel, { onClick: onClick, control: _jsx(Switch, { checked: is_active, name: "switcher", color: selected ? 'default' : 'primary' }), label: is_active ? 'Включен' : 'Выключен' }) }), _jsx(Hidden, { smUp: true, children: _jsx(FormControlLabel, { onClick: onClick, control: _jsx(Switch, { checked: is_active, name: "switcher", color: selected ? 'default' : 'primary' }), label: "" }) })] }));
});
